import { render } from "./Closings.vue?vue&type=template&id=34965762"
import script from "./Closings.vue?vue&type=script&lang=js"
export * from "./Closings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__